import { layoutScopeKeyFor } from 'modules/manager/domain/template-type';
import React from 'react';
import { LAYOUT_SCOPE_DESCRIPTORS } from '../common/layout-scope-descriptors';
import type { ObjectInspectorProps } from '../types';
import ScopeFilterSection from './scope-filter-section';

/**
 * Binds the selected objects to a slot of whatever dimension the active template
 * type repeats — a match block, a standings row, … — or renders nothing when the
 * type has no repeated slot. Replaces the former per-type wrappers
 * (MatchFilterSection / TeamPositionFilterSection): the type→scope mapping lives
 * in the template-type registry and the copy in LAYOUT_SCOPE_DESCRIPTORS, so a
 * new scope needs no new component here.
 */
const SlotFilterSection: React.FC<ObjectInspectorProps> = ({ objects, editor }) => {
  const scopeKey = layoutScopeKeyFor(editor.placeholders?.getTemplateType());

  return (
    <ScopeFilterSection objects={objects} editor={editor} descriptor={scopeKey ? LAYOUT_SCOPE_DESCRIPTORS[scopeKey] : undefined} />
  );
};

export default SlotFilterSection;
